import { DeviceKeys, Devices } from '@bingads-webui-campaign-react/xandr-campaign';
import { Scopes } from '@bingads-webui-campaign-react/goal-selector';
import { MinXandrDailyBudgetRangePerCurrency } from '@bingads-webui-campaign-legacy/common-grid-config/budget/get-budget-range';
import { generateNameSuggestionSuffix } from '@bingads-webui-campaign/audience-campaign-shared';
import { CampaignSubTypes } from '@bingads-webui-campaign-react/constants';
import { getTomorrow } from '../../shared/helper/format-date';
import { AdGroupCriterions, AgeRanges, GenderTypes } from '../../common/constants';
import { getBidRecommendations } from '../../shared/components/bid-recommendations-data';


export const getDefaultCampaign = (i18n, serverContext) => ({
  data: {
    Status: 'Paused',
    Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Display ads'))),
    Budget: {
      Amount: MinXandrDailyBudgetRangePerCurrency[serverContext.CurrentAccount.CurrencyCode],
      Type: 'DailyStandard',
    },
    Languages: [
      'All',
    ],
    BiddingScheme: {
      Type: 'ManualCpm',
    },
    CampaignSubType: 5,
    CampaignType: 'Audience',
    conversionGoals: {
      originalConversionGoals: [],
      goalSelection: [],
      goalScopeSelection: Scopes.ACCOUNT,
    },
  },
  isValid: true,
  isDirty: false,
  messages: [],
});

export const getDefaultAdGroup = (i18n, serverContext) => {
  const { CpmBid, SearchBid } = getBidRecommendations(serverContext, CampaignSubTypes.DisplayAds);

  return {
    data: {
      ...AdGroupCriterions,
      Status: 'Paused',
      Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Ad group'))),
      StartDate: getTomorrow(),
      locationTargets: {
        bidMode: false,
        currentLevelSettings: {
          initLocations: [],
          peopleInLocation: true,
          peopleSearchingForLocation: true,
          targetOption: 'everywhere',
        },
        parentLevelSettings: {},
        useParentLevel: false,
      },
      adSchedules: {
        dayTimeRanges: [],
      },
      deviceTypes: [
        DeviceKeys.Computers,
        DeviceKeys.Tablets,
        DeviceKeys.Smartphones,
      ],
      initialDeviceTypes: Object.keys(Devices).map(device => ({
        criterion: device,
        bidAdjustment: -100,
      })),
      ageRanges: [
        AgeRanges.EighteenToTwentyFive,
        AgeRanges.TwentyFiveToThirtyFive,
        AgeRanges.ThirtyFiveToFifty,
        AgeRanges.FiftyToSixtyFive,
        AgeRanges.SixtyFiveAndAbove,
        AgeRanges.Unknown,
      ],
      initialAgeRanges: [],
      genderTypes: [
        GenderTypes.Female,
        GenderTypes.Male,
        GenderTypes.Unknown,
      ],
      initialGenderTypes: [],
      audiences: [],
      initialAudiences: [],
      interests: [],
      initialInterests: [],
      FrequencyCapSettings: [
        {},
      ],
      genreTargets: [],
      initialGenreTargets: [],

      CpmBid,
      SearchBid,

      reachEstimation: null,
    },
    isValid: true,
    isDirty: true,
    messages: [],
  };
};
